import React from 'react';
import { LandingPageParagraph, LandingPageTitle, LandingPageWrapper, Logo, MainButton, LandingPageInternal } from './LandingPage.styled';
import logo from '../../assets/primaryLogo2.png';
import { useNavigate } from 'react-router-dom';

function LandingPage () {
   const navigate = useNavigate();

   return (
      <LandingPageWrapper>
         <LandingPageInternal>
            <Logo src={logo} alt="MFH Logo" onClick={() => window.open('https://chargeathome.org/', '_blank')}/>
            <LandingPageTitle>
            Charge at Home Project Builder Tool  
            </LandingPageTitle>
            <LandingPageParagraph>
               <div>
               This Tool generates site-specific EV charging infrastructure cost and financial metrics 
               estimations based on simple inputs entered about a multifamily property.
               </div>
               <div><b>
               By using the Charge at Home Project Builder Tool, you are illustrating your commitment to advancing access to EV charging at multifamily properties. Thank you. 
               </b></div>
            </LandingPageParagraph>
            <MainButton onClick={() => navigate('/input')}> Get Started </MainButton>
            <LandingPageParagraph>
            <div>
               <i>Data notice: Property address information will be collected to support research efforts related to EV charging at multifamily properties in the United States. No addresses will ever be published in any form. 
               No other personal information will be collected by <a href="https://forthmobility.org/" target='_blank' rel="noreferrer">Forth</a> or <a href="https://atlaspolicy.com/" target='_blank' rel="noreferrer">Atlas Public Policy</a> without your permission. 
               Data will not be shared with third parties or used for marketing purposes.</i>
            </div>
            </LandingPageParagraph>
         </LandingPageInternal>
      </LandingPageWrapper>
      )
};

LandingPage.propTypes = {};

export default LandingPage;
